<app-notifications></app-notifications>
<div class="checking-sign-document" *ngIf="loading">
    <p>Addebito prima quota in corso...
        <span>Resta in attesa delle verifiche in corso per poter finalizzare la richiesta</span>
    </p>
    <app-progress></app-progress>
</div>
